import React from "react";
import {Button} from "@/components/ui/button";
import BasePopup from "./BasePopup";

const CheckoutErrorPopup = ({isOpen, onClose}) => {
    return (
        <BasePopup isOpen={isOpen} onClose={onClose} aria-labelledby="checkout-error-title">
            <div className="text-center mb-6">
                <h3 id="checkout-error-title" className="text-xl font-bold text-red-600">
                    Unable to Start Payment
                </h3>
                <p className="text-gray-600 mt-2">
                    Unfortunately, we couldn't open the payment window.
                </p>
            </div>

            <div className="bg-red-50 rounded-lg p-4 mb-5 text-sm max-h-72 overflow-y-auto">
                <div className="text-gray-700 space-y-4">
                    <p>
                        This may be due to a browser incompatibility or network issue. Please try again later,
                        or contact our support team at{" "}
                        <a
                            href="mailto:support@jobpool.ai"
                            className="text-blue-600 underline hover:text-blue-800"
                        >
                            support@jobpool.ai
                        </a>{" "}
                        if the issue persists.
                    </p>
                </div>
            </div>

            <Button
                className="w-full bg-red-600 hover:bg-red-700 h-10 text-sm font-medium rounded-lg"
                onClick={onClose}
            >
                Close
            </Button>
        </BasePopup>
    );
};

export default CheckoutErrorPopup;